export const data = {
  recipes: [
    {
      vegetarian: true,
      vegan: true,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 3,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 11,
      spoonacularScore: 63.0,
      healthScore: 13.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 89.87,
      extendedIngredients: [
        {
          id: 99001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "coconut-milk.png",
          consistency: "liquid",
          name: "coconut milk beverage",
          nameClean: "coconut milk beverage",
          original: "1 cup unsweetened coconut beverage, divided",
          originalName: "unsweetened coconut beverage, divided",
          amount: 1.0,
          unit: "cup",
          meta: ["unsweetened", "divided"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 99009,
          aisle: "Canned and Jarred",
          image: "coconut-milk.jpg",
          consistency: "liquid",
          name: "light coconut milk",
          nameClean: "light coconut milk",
          original: "1 cup light coconut milk",
          originalName: "light coconut milk",
          amount: 1.0,
          unit: "cup",
          meta: ["light"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 9176,
          aisle: "Produce",
          image: "mango.jpg",
          consistency: "solid",
          name: "mango",
          nameClean: "mango",
          original: "1 cup mango, fresh or frozen",
          originalName: "mango, fresh or frozen",
          amount: 1.0,
          unit: "cup",
          meta: ["fresh"],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19911,
          aisle: "Cereal",
          image: "maple-syrup.png",
          consistency: "liquid",
          name: "maple syrup",
          nameClean: "maple syrup",
          original:
            "3 1/2 to 4 1/2 Tbs maple syrup, divided (add more if necessary)",
          originalName: "maple syrup, divided (add more if necessary)",
          amount: 3.5,
          unit: "Tbs",
          meta: ["divided", "(add more if necessary)"],
          measures: {
            us: { amount: 3.5, unitShort: "Tbs", unitLong: "Tbs" },
            metric: { amount: 3.5, unitShort: "Tbs", unitLong: "Tbs" },
          },
        },
        {
          id: 9266,
          aisle: "Produce",
          image: "pineapple.jpg",
          consistency: "solid",
          name: "pineapple",
          nameClean: "pineapple",
          original: "3/4 cup pineapple, fresh or frozen",
          originalName: "pineapple, fresh or frozen",
          amount: 0.75,
          unit: "cup",
          meta: ["fresh"],
          measures: {
            us: { amount: 0.75, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 177.441,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: null,
          aisle: "?",
          image: null,
          consistency: null,
          name: "popsicle moulds",
          nameClean: null,
          original: "6 popsicle moulds",
          originalName: "popsicle moulds",
          amount: 6.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 6.0, unitShort: "", unitLong: "" },
            metric: { amount: 6.0, unitShort: "", unitLong: "" },
          },
        },
      ],
      id: 663858,
      title: "Tropical Ice Pops",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl: "http://www.foodista.com/recipe/KCTN2T42/tropical-ice-pops",
      image: "https://spoonacular.com/recipeImages/663858-556x370.jpg",
      imageType: "jpg",
      summary:
        'Tropical Ice Pops might be just the dessert you are searching for. This recipe serves 6 and costs 93 cents per serving. Watching your figure? This gluten free and vegan recipe has <b>101 calories</b>, <b>0g of protein</b>, and <b>3g of fat</b> per serving. A mixture of pineapple, popsicle moulds, mango, and a handful of other ingredients are all it takes to make this recipe so delicious. This recipe is liked by 11 foodies and cooks. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 64%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/how-to-make-a-tropical-ice-cream-sandwich-908115">How to make a Tropical Ice Cream Sandwich</a>, <a href="https://spoonacular.com/recipes/cold-brew-coffee-latte-ice-pops-912354">Cold Brew Coffee Latte Ice Pops</a>, and <a href="https://spoonacular.com/recipes/tropical-strawberry-pops-450382">Tropical Strawberry Pops</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: [],
      instructions:
        "<ol><li>Pure the mango, pineapple, 3/4 cup coconut beverage and 1 1/2 tablespoon maple syrup in a blender.</li><li>Pour equal amounts of the mixture into each mould.</li><li>In a small bowl, mix the coconut milk, 1/4 cup of coconut beverage, and 2-3 TBS of maple syrup (adjust the sweetness to your taste).</li><li>Pour equal amounts of the coconut mixture on top of the fruit pure.</li><li>Insert a popsicle stick into each of the moulds, leaving about a quarter of the stick above the mould.</li><li>Freeze the popsicles for about 2 to 3 hours.</li><li>To remove the ice pops from the moulds, run them under warm to hot water for about 5 to 10 seconds before pulling them out.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Pure the mango, pineapple, 3/4 cup coconut beverage and 1 1/2 tablespoon maple syrup in a blender.",
              ingredients: [
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                {
                  id: 9266,
                  name: "pineapple",
                  localizedName: "pineapple",
                  image: "pineapple.jpg",
                },
                { id: 0, name: "drink", localizedName: "drink", image: "" },
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
                {
                  id: 9176,
                  name: "mango",
                  localizedName: "mango",
                  image: "mango.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
              ],
            },
            {
              number: 2,
              step: "Pour equal amounts of the mixture into each mould.In a small bowl, mix the coconut milk, 1/4 cup of coconut beverage, and 2-3 TBS of maple syrup (adjust the sweetness to your taste).",
              ingredients: [
                {
                  id: 12118,
                  name: "coconut milk",
                  localizedName: "coconut milk",
                  image: "coconut-milk.png",
                },
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                { id: 0, name: "drink", localizedName: "drink", image: "" },
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Pour equal amounts of the coconut mixture on top of the fruit pure.Insert a popsicle stick into each of the moulds, leaving about a quarter of the stick above the mould.Freeze the popsicles for about 2 to 3 hours.To remove the ice pops from the moulds, run them under warm to hot water for about 5 to 10 seconds before pulling them out.",
              ingredients: [
                {
                  id: 12104,
                  name: "coconut",
                  localizedName: "coconut",
                  image: "coconut.jpg",
                },
                {
                  id: 9431,
                  name: "fruit",
                  localizedName: "fruit",
                  image: "mixed-fresh-fruit.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 10014412,
                  name: "ice",
                  localizedName: "ice",
                  image: "ice-cubes.png",
                },
              ],
              equipment: [
                {
                  id: 408704,
                  name: "popsicle sticks",
                  localizedName: "popsicle sticks",
                  image: "popsicle-sticks.jpg",
                },
              ],
              length: { number: 180, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/tropical-ice-pops-663858",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 7,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 17,
      spoonacularScore: 19.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 55.35,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "2 large apples, peeled and diced",
          originalName: "apples, peeled and diced",
          amount: 2.0,
          unit: "large",
          meta: ["diced", "peeled"],
          measures: {
            us: { amount: 2.0, unitShort: "large", unitLong: "larges" },
            metric: { amount: 2.0, unitShort: "large", unitLong: "larges" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "light-brown-sugar.jpg",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 tablespoon brown sugar",
          originalName: "brown sugar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "4 ounces cream cheese, very cold and cubed",
          originalName: "cream cheese, very cold and cubed",
          amount: 4.0,
          unit: "ounces",
          meta: ["very cold", "cubed"],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1125,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-yolk.jpg",
          consistency: "solid",
          name: "egg yolk",
          nameClean: "egg yolk",
          original: "1 egg yolk",
          originalName: "egg yolk",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 18338,
          aisle: "Refrigerated;Frozen",
          image: "filo-dough.png",
          consistency: "solid",
          name: "filo dough",
          nameClean: "filo pastry",
          original: "Dough",
          originalName: "Dough",
          amount: 16.0,
          unit: "servings",
          meta: [],
          measures: {
            us: { amount: 16.0, unitShort: "servings", unitLong: "servings" },
            metric: {
              amount: 16.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "cups flour",
          originalName: "flour",
          amount: 1.0,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2001,
          aisle: "Spices and Seasonings",
          image: "allspice-ground.jpg",
          consistency: "solid",
          name: "ground allspice",
          nameClean: "allspice",
          original: "1/4 teaspoon ground allspice",
          originalName: "ground allspice",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2006,
          aisle: "Spices and Seasonings",
          image: "cardamom.jpg",
          consistency: "solid",
          name: "ground cardamom",
          nameClean: "cardamom",
          original: "1/8 teaspoon ground cardamom",
          originalName: "ground cardamom",
          amount: 0.125,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1012010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "ground cinnamon",
          nameClean: "ground cinnamon",
          original: "1/2 teaspoon ground cinnamon",
          originalName: "ground cinnamon",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2021,
          aisle: "Spices and Seasonings",
          image: "ginger.png",
          consistency: "solid",
          name: "ground ginger",
          nameClean: "ginger powder",
          original: "1/2 teaspoon ground ginger",
          originalName: "ground ginger",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "juice of lemon",
          nameClean: "lemon juice",
          original: "Juice of 1/2 lemon",
          originalName: "Juice lemon",
          amount: 0.5,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "", unitLong: "" },
            metric: { amount: 0.5, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 1082047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "kosher salt",
          nameClean: "kosher salt",
          original: "1/4 teaspoon kosher salt",
          originalName: "kosher salt",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 19911,
          aisle: "Cereal",
          image: "maple-syrup.png",
          consistency: "liquid",
          name: "maple syrup",
          nameClean: "maple syrup",
          original: "2 tablespoons maple syrup",
          originalName: "maple syrup",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "2 tablespoons milk",
          originalName: "milk",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 19336,
          aisle: "Baking",
          image: "powdered-sugar.jpg",
          consistency: "solid",
          name: "powdered sugar",
          nameClean: "powdered sugar",
          original: "1/8 cup powdered sugar",
          originalName: "powdered sugar",
          amount: 0.125,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 29.574,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "3 tablespoons Sugar",
          originalName: "Sugar",
          amount: 3.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "1/2 cup unsalted butter, very cold and cubed",
          originalName: "unsalted butter, very cold and cubed",
          amount: 0.5,
          unit: "cup",
          meta: ["unsalted", "very cold", "cubed"],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: null,
          aisle: "?",
          image: null,
          consistency: null,
          name: "frangelico",
          nameClean: null,
          original: "1 teaspoon Frangelico (or vanilla or rum)",
          originalName: "Frangelico (or vanilla or rum)",
          amount: 1.0,
          unit: "teaspoon",
          meta: ["(or vanilla or rum)"],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 652976,
      title: "Naturally Sweet Apple Turnovers",
      readyInMinutes: 45,
      servings: 16,
      sourceUrl:
        "http://www.foodista.com/recipe/TYW8P8Z5/naturally-sweet-apple-turnovers",
      image: "https://spoonacular.com/recipeImages/652976-556x370.jpg",
      imageType: "jpg",
      summary:
        'This recipe makes 16 servings with <b>200 calories</b>, <b>3g of protein</b>, and <b>10g of fat</b> each. For <b>54 cents per serving</b>, this recipe <b>covers 4%</b> of your daily requirements of vitamins and minerals. From preparation to the plate, this recipe takes around <b>45 minutes</b>. 17 people were impressed by this recipe. A mixture of frangelico, ground allspice, powdered sugar, and a handful of other ingredients are all it takes to make this recipe so tasty. It is a good option if you\'re following a <b>vegetarian</b> diet. All things considered, we decided this recipe <b>deserves a spoonacular score of 20%</b>. This score is rather bad. Similar recipes include <a href="https://spoonacular.com/recipes/naturally-sweet-honey-blondies-909220">Naturally Sweet Honey Blondies</a>, <a href="https://spoonacular.com/recipes/yam-or-sweet-potato-casserole-naturally-gluten-free-692138">Yam or Sweet Potato Casserole (Naturally Gluten Free)</a>, and <a href="https://spoonacular.com/recipes/sweet-potato-turnovers-with-sweet-kraut-188944">Sweet Potato Turnovers with Sweet Kraut</a>.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      instructions:
        "<ol><li>Start dough by whisking dry ingredients in a medium sized bowl. Add butter and incorporate with a pastry blender until coarse crumbs develop. Add cream cheese and incorporate well.</li><li>Plop in egg yolk and stir with a fork until dough comes together into a ball.</li><li>Turn dough out onto a floured surface and roll into a uniform ball. Slightly press flat with the palm of your hand and wrap in plastic wrap. Chill at least one hour.</li><li>Once dough has chilled, set it on a floured surface and roll it out to about 10 x 12. Cut into sixten even squares. Lay the dough squares on a parchment paper covered baking sheet and set in the freezer to chill.</li><li>In a separate bowl, toss the apples with the lemon juice, maple syrup, spices and brown sugar. Make sure to cover all of the apple pieces.</li><li>Take dough out of freezer. Drop about 1 tablespoon of filling into the center of each piece of dough. Fold one pointed edge towards its opposite corner to form a triangle.  Crimp edges with a fork along the seams. Repeat with all of the dough.</li><li>Brush a little milk over the top of each turnover and sprinkle with extra sugar if desired. (Pop back into the freezer for a quick chill if the dough is soft.). Bake in a preheated oven at 400 degrees for 20 minutes or until browned.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Start dough by whisking dry ingredients in a medium sized bowl.",
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
              ],
              equipment: [
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add butter and incorporate with a pastry blender until coarse crumbs develop.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
              ],
            },
            {
              number: 3,
              step: "Add cream cheese and incorporate well.Plop in egg yolk and stir with a fork until dough comes together into a ball.Turn dough out onto a floured surface and roll into a uniform ball. Slightly press flat with the palm of your hand and wrap in plastic wrap. Chill at least one hour.Once dough has chilled, set it on a floured surface and roll it out to about 10 x 1",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
              ],
              equipment: [
                {
                  id: 404730,
                  name: "plastic wrap",
                  localizedName: "plastic wrap",
                  image: "plastic-wrap.jpg",
                },
              ],
              length: { number: 60, unit: "minutes" },
            },
            {
              number: 4,
              step: "Cut into sixten even squares.",
              ingredients: [],
              equipment: [],
            },
            {
              number: 5,
              step: "Lay the dough squares on a parchment paper covered baking sheet and set in the freezer to chill.In a separate bowl, toss the apples with the lemon juice, maple syrup, spices and brown sugar. Make sure to cover all of the apple pieces.Take dough out of freezer. Drop about 1 tablespoon of filling into the center of each piece of dough. Fold one pointed edge towards its opposite corner to form a triangle.  Crimp edges with a fork along the seams. Repeat with all of the dough.",
              ingredients: [
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 19911,
                  name: "maple syrup",
                  localizedName: "maple syrup",
                  image: "maple-syrup.png",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 2035,
                  name: "spices",
                  localizedName: "spices",
                  image: "spices.png",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
              ],
              equipment: [
                {
                  id: 404770,
                  name: "baking paper",
                  localizedName: "baking paper",
                  image: "baking-paper.jpg",
                },
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Brush a little milk over the top of each turnover and sprinkle with extra sugar if desired. (Pop back into the freezer for a quick chill if the dough is soft.).",
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
                { id: 0, name: "pop", localizedName: "soft drink", image: "" },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Bake in a preheated oven at 400 degrees for 20 minutes or until browned.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 20, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/naturally-sweet-apple-turnovers-652976",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 9,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 7,
      spoonacularScore: 17.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 38.95,
      extendedIngredients: [
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "AP flour",
          nameClean: "wheat flour",
          original: "3 ¼ cups AP flour",
          originalName: "AP flour",
          amount: 3.25,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 3.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 768.911,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19904,
          aisle: "Sweet Snacks",
          image: "dark-chocolate-pieces.jpg",
          consistency: "solid",
          name: "dark chocolate",
          nameClean: "dark chocolate",
          original: "5-6 oz dark chocolate",
          originalName: "dark chocolate",
          amount: 5.0,
          unit: "oz",
          meta: ["dark"],
          measures: {
            us: { amount: 5.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 141.748, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 large egg",
          originalName: "egg",
          amount: 1.0,
          unit: "large",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "large", unitLong: "large" },
            metric: { amount: 1.0, unitShort: "large", unitLong: "large" },
          },
        },
        {
          id: 1125,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg-yolk.jpg",
          consistency: "solid",
          name: "egg yolk",
          nameClean: "egg yolk",
          original: "1 large egg yolk",
          originalName: "egg yolk",
          amount: 1.0,
          unit: "large",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "large", unitLong: "large" },
            metric: { amount: 1.0, unitShort: "large", unitLong: "large" },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "granulated sugar",
          nameClean: "sugar",
          original: "1 cup granulated sugar",
          originalName: "granulated sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "1-2 tablespoons milk",
          originalName: "milk",
          amount: 1.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 9216,
          aisle: "Produce",
          image: "orange-zest.png",
          consistency: "solid",
          name: "orange zest",
          nameClean: "orange zest",
          original: "3 tablespoons grated orange zest",
          originalName: "grated orange zest",
          amount: 3.0,
          unit: "tablespoons",
          meta: ["grated"],
          measures: {
            us: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 3.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1 teaspoon salt",
          originalName: "salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "1 ¼ cups unsalted butter, at room temp",
          originalName: "unsalted butter, at room temp",
          amount: 1.25,
          unit: "cups",
          meta: ["unsalted"],
          measures: {
            us: { amount: 1.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 295.735,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla extract",
          nameClean: "vanilla extract",
          original: "2 teaspoons vanilla extract",
          originalName: "vanilla extract",
          amount: 2.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 2.0, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
      ],
      id: 639644,
      title: "Classic Vanilla-Orange Sugar Cookies",
      readyInMinutes: 45,
      servings: 24,
      sourceUrl:
        "http://www.foodista.com/recipe/MTC5387V/classic-vanilla-orange-sugar-cookies",
      image: "https://spoonacular.com/recipeImages/639644-556x370.jpg",
      imageType: "jpg",
      summary:
        'Classic Vanilla-Orange Sugar Cookies might be just the dessert you are searching for. This vegetarian recipe serves 24 and costs <b>39 cents per serving</b>. One serving contains <b>221 calories</b>, <b>3g of protein</b>, and <b>13g of fat</b>. It can be enjoyed any time, but it is especially good for <b>Christmas</b>. This recipe is liked by 7 foodies and cooks. If you have ap flour, orange zest, vanillan extract, and a few other ingredients on hand, you can make it. From preparation to the plate, this recipe takes about <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 18%</b>. This score is rather bad. Try <a href="https://spoonacular.com/recipes/classic-sugar-cookies-738947">Classic Sugar Cookies</a>, <a href="https://spoonacular.com/recipes/classic-sugar-cookies-144316">Classic Sugar Cookies</a>, and <a href="https://spoonacular.com/recipes/classic-sugar-cookies-595721">Classic Sugar Cookies</a> for similar recipes.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: ["christmas"],
      instructions:
        "<ol><li>In a medium bowl, whisk together flour and salt.</li><li>In bowl of stand mixer, beat sugar and butter on medium speed until light and fluffy, about 3 minutes.  Beat in egg, egg yolk, orange zest and vanilla until well combined.</li><li>With the mixer on low speed, gradually add flour mixture to bowl, mixing until combined.</li><li>Turn dough out onto a work surface and divide into three equal pieces. Shape each piece into a flat disk.  Wrap each disk tightly in plastic wrap.  Refrigerate for at least 1 hour, until cold, or for up to 3 days.</li><li>Preheat oven to 350 degrees F, placing racks in the upper and lower thirds.</li><li>On a lightly floured work surface, roll out one disk of dough to a thickness of  inch.  Using cookie cutter, cut out shapes and carefully transfer them to 2 prepared cookie sheets, spacing them about 1 inch apart.  Reroll scraps as necessary.  Repeat process with more dough until both cookie sheets are full.</li><li>Bake for 11  15 minutes, switching positions of cookie sheets halfway through, until cookies are set and very lightly browned.  Let cookies cool on cookie sheet for 10 minutes, then carefully transfer them to wire racks to cool completely before decorating.</li><li>Repeat steps 6 and 7 with the remaining dough.</li><li>Melt chocolate and milk in a double broiler.  When cookies are cool, drizzle over the cookies and allow to set.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a medium bowl, whisk together flour and salt.In bowl of stand mixer, beat sugar and butter on medium speed until light and fluffy, about 3 minutes.  Beat in egg, egg yolk, orange zest and vanilla until well combined.With the mixer on low speed, gradually add flour mixture to bowl, mixing until combined.Turn dough out onto a work surface and divide into three equal pieces. Shape each piece into a flat disk.  Wrap each disk tightly in plastic wrap.  Refrigerate for at least 1 hour, until cold, or for up to 3 days.Preheat oven to 350 degrees F, placing racks in the upper and lower thirds.On a lightly floured work surface, roll out one disk of dough to a thickness of  inch.  Using cookie cutter, cut out shapes and carefully transfer them to 2 prepared cookie sheets, spacing them about 1 inch apart.  Reroll scraps as necessary.  Repeat process with more dough until both cookie sheets are full.",
              ingredients: [
                {
                  id: 9216,
                  name: "orange zest",
                  localizedName: "orange zest",
                  image: "orange-zest.png",
                },
                {
                  id: 1125,
                  name: "egg yolk",
                  localizedName: "egg yolk",
                  image: "egg-yolk.jpg",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
                {
                  id: 10018364,
                  name: "wrap",
                  localizedName: "wrap",
                  image: "flour-tortilla.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [
                {
                  id: 221429,
                  name: "cookie cutter",
                  localizedName: "cookie cutter",
                  image: "cookie-cutters.jpg",
                },
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404730,
                  name: "plastic wrap",
                  localizedName: "plastic wrap",
                  image: "plastic-wrap.jpg",
                },
                {
                  id: 404665,
                  name: "stand mixer",
                  localizedName: "stand mixer",
                  image: "stand-mixer.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 350.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 63, unit: "minutes" },
            },
            {
              number: 2,
              step: "Bake for 11  15 minutes, switching positions of cookie sheets halfway through, until cookies are set and very lightly browned.",
              ingredients: [
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 15, unit: "minutes" },
            },
            {
              number: 3,
              step: "Let cookies cool on cookie sheet for 10 minutes, then carefully transfer them to wire racks to cool completely before decorating.Repeat steps 6 and 7 with the remaining dough.Melt chocolate and milk in a double broiler.  When cookies are cool, drizzle over the cookies and allow to set.",
              ingredients: [
                {
                  id: 19081,
                  name: "chocolate",
                  localizedName: "chocolate",
                  image: "milk-chocolate.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
                {
                  id: 405914,
                  name: "broiler",
                  localizedName: "broiler",
                  image: "oven.jpg",
                },
              ],
              length: { number: 10, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/classic-vanilla-orange-sugar-cookies-639644",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 5,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 7,
      spoonacularScore: 42.0,
      healthScore: 6.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 83.9,
      extendedIngredients: [
        {
          id: 2048,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "apple-cider-vinegar.jpg",
          consistency: "liquid",
          name: "apple cider vinegar",
          nameClean: "apple cider vinegar",
          original: "1 tablespoon apple cider vinegar",
          originalName: "apple cider vinegar",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic cloves",
          nameClean: "garlic",
          original: "3 garlic cloves thinly sliced",
          originalName: "garlic cloves thinly sliced",
          amount: 3.0,
          unit: "",
          meta: ["thinly sliced"],
          measures: {
            us: { amount: 3.0, unitShort: "", unitLong: "" },
            metric: { amount: 3.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 11052,
          aisle: "Produce",
          image: "green-beans-or-string-beans.jpg",
          consistency: "solid",
          name: "green beans",
          nameClean: "green beans",
          original: "1 1/2 pounds green beans, trimmed",
          originalName: "green beans, trimmed",
          amount: 1.5,
          unit: "pounds",
          meta: ["trimmed"],
          measures: {
            us: { amount: 1.5, unitShort: "lb", unitLong: "pounds" },
            metric: { amount: 680.389, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "2 tablespoons extra-virgin olive oil",
          originalName: "extra-virgin olive oil",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["extra-virgin"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "salt and pepper",
          nameClean: "salt and pepper",
          original: "Slavosalt seasoning – or salt and pepper",
          originalName: "Slavosalt seasoning – or salt and pepper",
          amount: 4.0,
          unit: "servings",
          meta: [],
          measures: {
            us: { amount: 4.0, unitShort: "servings", unitLong: "servings" },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 1145,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "unsalted butter",
          nameClean: "unsalted butter",
          original: "2 tablespoon unsalted butter + ½ teaspoon",
          originalName: "unsalted butter + ½ teaspoon",
          amount: 2.0,
          unit: "tablespoon",
          meta: ["unsalted"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1012069,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vinegar-(white).jpg",
          consistency: "liquid",
          name: "white balsamic vinegar",
          nameClean: "white balsamic vinegar",
          original: "1 tablespoon white balsamic vinegar",
          originalName: "white balsamic vinegar",
          amount: 1.0,
          unit: "tablespoon",
          meta: ["white"],
          measures: {
            us: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
            metric: { amount: 1.0, unitShort: "Tbsp", unitLong: "Tbsp" },
          },
        },
        {
          id: 10511282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "yellow onion",
          nameClean: "yellow onion",
          original: "½ yellow onion, sliced",
          originalName: "yellow onion, sliced",
          amount: 0.5,
          unit: "",
          meta: ["yellow", "sliced"],
          measures: {
            us: { amount: 0.5, unitShort: "", unitLong: "" },
            metric: { amount: 0.5, unitShort: "", unitLong: "" },
          },
        },
      ],
      id: 645416,
      title: "Green Beans with Garlic Chips",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl:
        "http://www.foodista.com/recipe/4D3H7QM3/green-beans-with-garlic-chips",
      image: "https://spoonacular.com/recipeImages/645416-556x370.jpg",
      imageType: "jpg",
      summary:
        'Green Beans with Garlic Chips might be just the side dish you are searching for. One serving contains <b>178 calories</b>, <b>3g of protein</b>, and <b>13g of fat</b>. This gluten free, primal, and vegetarian recipe serves 4 and costs <b>84 cents per serving</b>. 7 people have tried and liked this recipe. If you have apple cider vinegar, garlic cloves, olive oil, and a few other ingredients on hand, you can make it. From preparation to the plate, this recipe takes roughly <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 45%</b>. This score is solid. Try <a href="https://spoonacular.com/recipes/sauteed-green-beans-with-garlic-chips-395227">Sauteed Green Beans with Garlic Chips</a>, <a href="https://spoonacular.com/recipes/garlic-green-beans-644285">Garlic Green Beans</a>, and <a href="https://spoonacular.com/recipes/garlic-green-beans-433417">Garlic Green Beans</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["gluten free", "lacto ovo vegetarian", "primal"],
      occasions: [],
      instructions:
        "<ol><li>Heat the oil with the garlic in a heavy skillet over medium heat. Cook stirring occasionally, until the garlic is golden. Remove the garlic from the skillet with a slotted spoon and transfer to a paper towel.</li><li>Add the butter to the oil in the skillet and heat over medium heat. Add the onions, salt and pepper and saut, until the onions are translucent and starting to turn golden.</li><li>Add the beans and continue cooking stirring occasionally. Stir in both vinegars and season with salt and pepper to taste.</li><li>Transfer the beans to a serving dish and sprinkle with the garlic chips.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Heat the oil with the garlic in a heavy skillet over medium heat. Cook stirring occasionally, until the garlic is golden.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 2,
              step: "Remove the garlic from the skillet with a slotted spoon and transfer to a paper towel.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
              ],
              equipment: [
                {
                  id: 404636,
                  name: "slotted spoon",
                  localizedName: "slotted spoon",
                  image: "slotted-spoon.jpg",
                },
                {
                  id: 405895,
                  name: "paper towels",
                  localizedName: "paper towels",
                  image: "paper-towels.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 3,
              step: "Add the butter to the oil in the skillet and heat over medium heat.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 4,
              step: "Add the onions, salt and pepper and saut, until the onions are translucent and starting to turn golden.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [],
            },
            {
              number: 5,
              step: "Add the beans and continue cooking stirring occasionally. Stir in both vinegars and season with salt and pepper to taste.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 0,
                  name: "beans",
                  localizedName: "beans",
                  image: "kidney-beans.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Transfer the beans to a serving dish and sprinkle with the garlic chips.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 0,
                  name: "beans",
                  localizedName: "beans",
                  image: "kidney-beans.jpg",
                },
                {
                  id: 11408,
                  name: "french fries",
                  localizedName: "french fries",
                  image: "french-fries-isolated.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/green-beans-with-garlic-chips-645416",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 12,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 34,
      spoonacularScore: 24.0,
      healthScore: 1.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 110.25,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "7-8 baking apples (ie: Granny Smith)",
          originalName: "baking apples (ie: Granny Smith)",
          amount: 7.0,
          unit: "",
          meta: ["(ie: Granny Smith)"],
          measures: {
            us: { amount: 7.0, unitShort: "", unitLong: "" },
            metric: { amount: 7.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 9021,
          aisle: "Produce",
          image: "apricot.jpg",
          consistency: "solid",
          name: "apricot",
          nameClean: "apricot",
          original: "4-5 Tbs apricot preserve melted",
          originalName: "apricot preserve melted",
          amount: 4.0,
          unit: "Tbs",
          meta: ["melted"],
          measures: {
            us: { amount: 4.0, unitShort: "Tbs", unitLong: "Tbs" },
            metric: { amount: 4.0, unitShort: "Tbs", unitLong: "Tbs" },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1 stick butter, softened",
          originalName: "butter, softened",
          amount: 1.0,
          unit: "stick",
          meta: ["softened"],
          measures: {
            us: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
            metric: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1/2 teaspoon Cinnamon",
          originalName: "Cinnamon",
          amount: 0.5,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "2 -8oz packages cream cheese softened",
          originalName: "packages cream cheese softened",
          amount: 2.0,
          unit: "oz",
          meta: ["softened"],
          measures: {
            us: { amount: 2.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 56.699, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "eggs",
          nameClean: "egg",
          original: "2 eggs",
          originalName: "eggs",
          amount: 2.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "", unitLong: "" },
            metric: { amount: 2.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 18617,
          aisle: "Sweet Snacks",
          image: "graham-crackers.jpg",
          consistency: "solid",
          name: "graham crackers",
          nameClean: "graham crackers",
          original: "8-9 Graham crackers finely chopped to crumbs = 1+ cups",
          originalName: "Graham crackers finely chopped to crumbs = 1+ cups",
          amount: 8.0,
          unit: "",
          meta: ["finely chopped"],
          measures: {
            us: { amount: 8.0, unitShort: "", unitLong: "" },
            metric: { amount: 8.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 12142,
          aisle: "Nuts;Baking",
          image: "pecans.jpg",
          consistency: "solid",
          name: "pecans",
          nameClean: "pecans",
          original: "1/4 cup chopped pecans",
          originalName: "chopped pecans",
          amount: 0.25,
          unit: "cup",
          meta: ["chopped"],
          measures: {
            us: { amount: 0.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "1/2 cup sugar",
          originalName: "sugar",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla",
          nameClean: "vanilla extract",
          original: "1/2 tsp vanilla",
          originalName: "vanilla",
          amount: 0.5,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
      ],
      id: 633091,
      title: "Autumn Cheesecake",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl: "http://www.foodista.com/recipe/2HQGVX53/autumn-cheesecake",
      image: "https://spoonacular.com/recipeImages/633091-556x370.jpg",
      imageType: "jpg",
      summary:
        'Watching your figure? This vegetarian recipe has <b>358 calories</b>, <b>4g of protein</b>, and <b>19g of fat</b> per serving. For <b>$1.1 per serving</b>, this recipe <b>covers 6%</b> of your daily requirements of vitamins and minerals. A couple people made this recipe, and 34 would say it hit the spot. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. Head to the store and pick up cream cheese, pecans, butter, and a few other things to make it today. All things considered, we decided this recipe <b>deserves a spoonacular score of 26%</b>. This score is not so great. Try <a href="https://spoonacular.com/recipes/autumn-apple-cheesecake-760758">Autumn Apple Cheesecake</a>, <a href="https://spoonacular.com/recipes/caramel-apple-butter-cheesecake-dip-for-sundaysupper-autumn-apple-party-554054">Caramel Apple Butter Cheesecake Dip for #SundaySupper Autumn Apple Party</a>, and <a href="https://spoonacular.com/recipes/california-pizza-kitchen-pumpkin-cheesecake-this-is-a-perfect-cheesecake-for-the-fall-holidays-their-cheesecake-isnt-a-secret-anymore-600275">California Pizza Kitchen Pumpkin Cheesecake – this is a perfect cheesecake for the fall holidays, their cheesecake isn’t a secret anymore</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      instructions:
        "<ol><li>FOR THE APPLE LAYER:</li><li>Peel and core the apples and slice thinly add to the sugar and cinnamon and mix well until all the apples are coated.  Set aside.</li><li>FOR THE CRUST:</li><li>Preheat oven to 350</li><li>In a small sauce pan melt the butter</li><li>In the food processor add the pecans and chop until very fine, add the Graham crackers and pulse until finely chopped and put mixture into a bowl.  Add the butter and with a fork stir to combine, until all the cracker is wet with butter and no dry parts are still visible.</li><li>Place the mixture into the bottom of a 9 inch springform pan and press down to form a solid bottom crust.  Place into the center of the oven and bake for about 10 minutes, remove to a wire rack to cool..</li><li>FOR THE BATTER:</li><li>In the bowl of the mixer place the softened cream cheese and the sugar and on medium speed cream until well  combined, scrape down the sides of the bowl and the blades of the mixer add the vanilla and on medium low add the eggs one at a time and continue to beat until each is well incorporated.  Pour into the cooled springform pan and smooth the mixture level.</li><li>APPLES:</li><li>Arrange the apples in decorative layer over the batter and then place the pan into the oven and bake for about 70 minutes.</li><li>Remove to a wire rack to cool.</li><li>In the mean time melt the preserve and once the apples a lightly cooled brush the preserve over apples to coat all and give a nice sheen to the top.  Sprinkle the pecans over the apples.  Now carefully run a knife around the edges of the cake to loosen from the sides of the pan and then cover and refrigerate for at least 5 hours, overnight even better.</li><li>Remove from the refrigerator about an hour before serving and remove the sides of the springform  pan.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "FOR THE APPLE LAYER:Peel and core the apples and slice thinly add to the sugar and cinnamon and mix well until all the apples are coated.  Set aside.FOR THE CRUST:Preheat oven to 350In a small sauce pan melt the butter",
              ingredients: [
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                { id: 0, name: "crust", localizedName: "crust", image: "" },
                { id: 0, name: "sauce", localizedName: "sauce", image: "" },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "In the food processor add the pecans and chop until very fine, add the Graham crackers and pulse until finely chopped and put mixture into a bowl.",
              ingredients: [
                {
                  id: 18617,
                  name: "graham crackers",
                  localizedName: "graham crackers",
                  image: "graham-crackers.jpg",
                },
                {
                  id: 12142,
                  name: "pecans",
                  localizedName: "pecans",
                  image: "pecans.jpg",
                },
              ],
              equipment: [
                {
                  id: 404771,
                  name: "food processor",
                  localizedName: "food processor",
                  image: "food-processor.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Add the butter and with a fork stir to combine, until all the cracker is wet with butter and no dry parts are still visible.",
              ingredients: [
                {
                  id: 18621,
                  name: "crackers",
                  localizedName: "crackers",
                  image: "crackers.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Place the mixture into the bottom of a 9 inch springform pan and press down to form a solid bottom crust.",
              ingredients: [
                { id: 0, name: "crust", localizedName: "crust", image: "" },
              ],
              equipment: [
                {
                  id: 404650,
                  name: "springform pan",
                  localizedName: "springform pan",
                  image: "cake-pan.png",
                },
              ],
            },
            {
              number: 5,
              step: "Place into the center of the oven and bake for about 10 minutes, remove to a wire rack to cool..FOR THE BATTER:In the bowl of the mixer place the softened cream cheese and the sugar and on medium speed cream until well  combined, scrape down the sides of the bowl and the blades of the mixer add the vanilla and on medium low add the eggs one at a time and continue to beat until each is well incorporated.",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: { number: 10, unit: "minutes" },
            },
            {
              number: 6,
              step: "Pour into the cooled springform pan and smooth the mixture level.APPLES:Arrange the apples in decorative layer over the batter and then place the pan into the oven and bake for about 70 minutes.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 404650,
                  name: "springform pan",
                  localizedName: "springform pan",
                  image: "cake-pan.png",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 70, unit: "minutes" },
            },
            {
              number: 7,
              step: "Remove to a wire rack to cool.In the mean time melt the preserve and once the apples a lightly cooled brush the preserve over apples to coat all and give a nice sheen to the top.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 405900,
                  name: "wire rack",
                  localizedName: "wire rack",
                  image: "wire-rack.jpg",
                },
              ],
            },
            {
              number: 8,
              step: "Sprinkle the pecans over the apples.  Now carefully run a knife around the edges of the cake to loosen from the sides of the pan and then cover and refrigerate for at least 5 hours, overnight even better.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
                {
                  id: 12142,
                  name: "pecans",
                  localizedName: "pecans",
                  image: "pecans.jpg",
                },
              ],
              equipment: [
                {
                  id: 404745,
                  name: "knife",
                  localizedName: "knife",
                  image: "chefs-knife.jpg",
                },
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: { number: 300, unit: "minutes" },
            },
            {
              number: 9,
              step: "Remove from the refrigerator about an hour before serving and remove the sides of the springform  pan.",
              ingredients: [],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/autumn-cheesecake-633091",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 26,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 122,
      spoonacularScore: 57.0,
      healthScore: 6.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 205.62,
      extendedIngredients: [
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "8 oz Cream Cheese",
          originalName: "Cream Cheese",
          amount: 8.0,
          unit: "oz",
          meta: [],
          measures: {
            us: { amount: 8.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 226.796, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1022020,
          aisle: "Spices and Seasonings",
          image: "garlic-powder.png",
          consistency: "solid",
          name: "garlic powder",
          nameClean: "garlic powder",
          original: "grated ½ tsp Garlic Powder",
          originalName: "grated Garlic Powder",
          amount: 0.5,
          unit: "tsp",
          meta: ["grated"],
          measures: {
            us: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.5, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 31015,
          aisle: "Produce",
          image: "chili-peppers-green.jpg",
          consistency: "solid",
          name: "green chilis",
          nameClean: "green chili pepper",
          original: "4 oz Green Chilis (1 small can)",
          originalName: "Green Chilis (1 small can)",
          amount: 4.0,
          unit: "oz",
          meta: ["green", "(1 small can)"],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
        {
          id: 1031009,
          aisle: "Cheese",
          image: "cheddar-cheese.png",
          consistency: "solid",
          name: "sharp cheddar cheese",
          nameClean: "sharp cheddar cheese",
          original: "4 oz Sharp Cheddar Cheese",
          originalName: "Sharp Cheddar Cheese",
          amount: 4.0,
          unit: "oz",
          meta: [],
          measures: {
            us: { amount: 4.0, unitShort: "oz", unitLong: "ounces" },
            metric: { amount: 113.398, unitShort: "g", unitLong: "grams" },
          },
        },
      ],
      id: 715602,
      title: "Green Chili Cheddar Dip (Guest Post)",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl: "http://www.pinkwhen.com/green-chili-cheddar-dip-guest-post/",
      image: "https://spoonacular.com/recipeImages/715602-556x370.png",
      imageType: "png",
      summary:
        'The recipe Green Chili Cheddar Dip (Guest Post) could satisfy your American craving in roughly <b>45 minutes</b>. This recipe serves 2 and costs $2.06 per serving. One serving contains <b>634 calories</b>, <b>21g of protein</b>, and <b>58g of fat</b>. Plenty of people really liked this hor d\'oeuvre. It can be enjoyed any time, but it is especially good for <b>The Super Bowl</b>. A mixture of cream cheese, garlic powder, chilis, and a handful of other ingredients are all it takes to make this recipe so yummy. It is a good option if you\'re following a <b>gluten free, primal, and vegetarian</b> diet. 122 people were impressed by this recipe. All things considered, we decided this recipe <b>deserves a spoonacular score of 60%</b>. This score is good. Try <a href="https://spoonacular.com/recipes/guest-post-from-diethood-garlic-and-cheddar-drop-biscuits-515122">Guest Post from Diethood – Garlic and Cheddar Drop Biscuits</a>, <a href="https://spoonacular.com/recipes/turkey-picadillo-quinoa-chili-guest-post-505017">Turkey Picadillo Quinoa Chili {guest post}</a>, and <a href="https://spoonacular.com/recipes/guest-post-slow-cooker-veggie-chili-582423">Guest Post: Slow Cooker Veggie Chili</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["condiment", "dip", "spread"],
      diets: ["gluten free", "lacto ovo vegetarian", "primal"],
      occasions: ["super bowl"],
      instructions:
        "In a medium bowl microwave the cream cheese for 30-60 seconds or until it is softened.Mix in the green chilis, cheddar, and garlic. Mix well.Microwave the dip for 45 seconds, stir and then an additional 45 seconds or until it is heated through.Alternately, you can spread the mixture in a baking dish and bake at 350 degrees F for 20-30 min or until heated through.Serve with tortilla chips and enjoy the game (or the food!)",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "In a medium bowl microwave the cream cheese for 30-60 seconds or until it is softened.",
              ingredients: [
                {
                  id: 1017,
                  name: "cream cheese",
                  localizedName: "cream cheese",
                  image: "cream-cheese.jpg",
                },
              ],
              equipment: [
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Mix in the green chilis, cheddar, and garlic.",
              ingredients: [
                {
                  id: 31015,
                  name: "green chili pepper",
                  localizedName: "green chili pepper",
                  image: "chili-peppers-green.jpg",
                },
                {
                  id: 1009,
                  name: "cheddar cheese",
                  localizedName: "cheddar cheese",
                  image: "cheddar-cheese.png",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Mix well.Microwave the dip for 45 seconds, stir and then an additional 45 seconds or until it is heated through.Alternately, you can spread the mixture in a baking dish and bake at 350 degrees F for 20-30 min or until heated through.",
              ingredients: [
                { id: 0, name: "spread", localizedName: "spread", image: "" },
                { id: 0, name: "dip", localizedName: "dip", image: "" },
              ],
              equipment: [
                {
                  id: 404646,
                  name: "baking pan",
                  localizedName: "baking pan",
                  image: "roasting-pan.jpg",
                },
                {
                  id: 404762,
                  name: "microwave",
                  localizedName: "microwave",
                  image: "microwave.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 350.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 30, unit: "minutes" },
            },
            {
              number: 4,
              step: "Serve with tortilla chips and enjoy the game (or the food!)",
              ingredients: [
                {
                  id: 19056,
                  name: "tortilla chips",
                  localizedName: "tortilla chips",
                  image: "tortilla-chips.jpg",
                },
                {
                  id: 0,
                  name: "game meat",
                  localizedName: "game meat",
                  image: "whole-chicken.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/green-chili-cheddar-dip-guest-post-715602",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 8,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 130,
      spoonacularScore: 15.0,
      healthScore: 0.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 21.14,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apple",
          nameClean: "apple",
          original: "2 cups chopped apple",
          originalName: "chopped apple",
          amount: 2.0,
          unit: "cups",
          meta: ["chopped"],
          measures: {
            us: { amount: 2.0, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 18372,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking soda",
          nameClean: "baking soda",
          original: "1 teaspoon baking soda",
          originalName: "baking soda",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "light-brown-sugar.jpg",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 cup brown sugar",
          originalName: "brown sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1/2 cup butter",
          originalName: "butter",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1 teaspoon cinnamon",
          originalName: "cinnamon",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 egg",
          originalName: "egg",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "2 cups flour",
          originalName: "flour",
          amount: 2.0,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 2.0, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2011,
          aisle: "Spices and Seasonings",
          image: "cloves.jpg",
          consistency: "solid",
          name: "ground cloves",
          nameClean: "ground clove",
          original: "1/4 teaspoon ground cloves",
          originalName: "ground cloves",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 11111111,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "solid",
          name: "maple flavoring",
          nameClean: "maple flavoring",
          original: "1/4 teaspoon maple flavoring",
          originalName: "maple flavoring",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 1077,
          aisle: "Milk, Eggs, Other Dairy",
          image: "milk.png",
          consistency: "liquid",
          name: "milk",
          nameClean: "milk",
          original: "1/4 cup milk",
          originalName: "milk",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2025,
          aisle: "Spices and Seasonings",
          image: "ground-nutmeg.jpg",
          consistency: "solid",
          name: "nutmeg",
          nameClean: "nutmeg",
          original: "1/4 teaspoon nutmeg",
          originalName: "nutmeg",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 19336,
          aisle: "Baking",
          image: "powdered-sugar.jpg",
          consistency: "solid",
          name: "powdered sugar",
          nameClean: "powdered sugar",
          original: "1 cup powdered sugar",
          originalName: "powdered sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1 teaspoon salt",
          originalName: "salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 650939,
      title: "Maple-Glazed Apple Cookies",
      readyInMinutes: 45,
      servings: 18,
      sourceUrl:
        "http://www.foodista.com/recipe/ZCJS73TL/maple-glazed-apple-cookies",
      image: "https://spoonacular.com/recipeImages/650939-556x370.jpg",
      imageType: "jpg",
      summary:
        'Maple-Glazed Apple Cookies might be just the dessert you are searching for. For <b>21 cents per serving</b>, this recipe <b>covers 3%</b> of your daily requirements of vitamins and minerals. One serving contains <b>181 calories</b>, <b>2g of protein</b>, and <b>6g of fat</b>. This recipe from Foodista has 130 fans. From preparation to the plate, this recipe takes roughly <b>45 minutes</b>. It is a good option if you\'re following a <b>vegetarian</b> diet. A mixture of apple, nutmeg, brown sugar, and a handful of other ingredients are all it takes to make this recipe so scrumptious. All things considered, we decided this recipe <b>deserves a spoonacular score of 16%</b>. This score is not so tremendous. Try <a href="https://spoonacular.com/recipes/maple-glazed-apple-crisp-cookies-621623">Maple-Glazed Apple Crisp Cookies</a>, <a href="https://spoonacular.com/recipes/maple-glazed-apple-pie-435364">Maple-Glazed Apple Pie</a>, and <a href="https://spoonacular.com/recipes/glazed-maple-cookies-141990">Glazed Maple Cookies</a> for similar recipes.',
      cuisines: [],
      dishTypes: [
        "antipasti",
        "starter",
        "snack",
        "appetizer",
        "antipasto",
        "hor d'oeuvre",
      ],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      instructions:
        "<ol><li>Preheat oven to 400 degrees F.</li><li>Cream 1/2 cup butter and sugar together in a large mixing bowl until light in color, about 1-2 minutes. Add egg and 1/4 cup milk; stir to combine. Add remaining dry ingredients (except apple) and stir just until combined. Gently fold in the apples.  Drop by heaping tablespoons onto a greased baking sheet.</li><li>Bake at 400 for about 10-12 min or until tops don't look wet anymore.</li><li>To make the glaze, whisk together 1 tablespoon melted butter, 1 cup powdered sugar, 1/4 tsp maple flavoring, and 3 tablespoons milk in a small bowl. When the cookies have cooled for a few minutes, drizzle each cookie with glaze.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat oven to 400 degrees F.Cream 1/2 cup butter and sugar together in a large mixing bowl until light in color, about 1-2 minutes.",
              ingredients: [
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
              ],
              equipment: [
                {
                  id: 405907,
                  name: "mixing bowl",
                  localizedName: "mixing bowl",
                  image: "mixing-bowl.jpg",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                  temperature: { number: 400.0, unit: "Fahrenheit" },
                },
              ],
              length: { number: 2, unit: "minutes" },
            },
            {
              number: 2,
              step: "Add egg and 1/4 cup milk; stir to combine.",
              ingredients: [
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Add remaining dry ingredients (except apple) and stir just until combined. Gently fold in the apples.  Drop by heaping tablespoons onto a greased baking sheet.",
              ingredients: [
                {
                  id: 9003,
                  name: "apple",
                  localizedName: "apple",
                  image: "apple.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
              ],
            },
            {
              number: 4,
              step: "Bake at 400 for about 10-12 min or until tops don't look wet anymore.To make the glaze, whisk together 1 tablespoon melted butter, 1 cup powdered sugar, 1/4 tsp maple flavoring, and 3 tablespoons milk in a small bowl. When the cookies have cooled for a few minutes, drizzle each cookie with glaze.",
              ingredients: [
                {
                  id: 11111111,
                  name: "maple flavoring",
                  localizedName: "maple flavoring",
                  image: "vanilla-extract.jpg",
                },
                {
                  id: 19336,
                  name: "powdered sugar",
                  localizedName: "powdered sugar",
                  image: "powdered-sugar.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                { id: 0, name: "glaze", localizedName: "glaze", image: "" },
                {
                  id: 1077,
                  name: "milk",
                  localizedName: "milk",
                  image: "milk.png",
                },
              ],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: { number: 12, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/maple-glazed-apple-cookies-650939",
    },
    {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 14,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 39,
      spoonacularScore: 29.0,
      healthScore: 2.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 37.57,
      extendedIngredients: [
        {
          id: 2001,
          aisle: "Spices and Seasonings",
          image: "allspice-ground.jpg",
          consistency: "solid",
          name: "allspice",
          nameClean: "allspice",
          original: "1/4 tsp Allspice",
          originalName: "Allspice",
          amount: 0.25,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.25, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 18371,
          aisle: "Baking",
          image: "white-powder.jpg",
          consistency: "solid",
          name: "baking powder",
          nameClean: "low sodium baking powder",
          original: "1 tsp Baking Powder",
          originalName: "Baking Powder",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19334,
          aisle: "Baking",
          image: "light-brown-sugar.jpg",
          consistency: "solid",
          name: "brown sugar",
          nameClean: "golden brown sugar",
          original: "1 cup Brown Sugar",
          originalName: "Brown Sugar",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "cup", unitLong: "cup" },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1001,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "butter",
          nameClean: "butter",
          original: "1 stick Butter",
          originalName: "Butter",
          amount: 1.0,
          unit: "stick",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
            metric: { amount: 1.0, unitShort: "stick", unitLong: "stick" },
          },
        },
        {
          id: 2010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "cinnamon",
          nameClean: "cinnamon",
          original: "1 tsp Cinnamon",
          originalName: "Cinnamon",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
        {
          id: 19165,
          aisle: "Baking",
          image: "cocoa-powder.png",
          consistency: "solid",
          name: "cocoa powder",
          nameClean: "cacao powder",
          original: "2 Tbsp Cocoa Powder (Optional)",
          originalName: "Cocoa Powder (Optional)",
          amount: 2.0,
          unit: "Tbsp",
          meta: ["(Optional)"],
          measures: {
            us: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
            metric: { amount: 2.0, unitShort: "Tbsps", unitLong: "Tbsps" },
          },
        },
        {
          id: 1123,
          aisle: "Milk, Eggs, Other Dairy",
          image: "egg.png",
          consistency: "solid",
          name: "egg",
          nameClean: "egg",
          original: "1 Egg",
          originalName: "Egg",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "", unitLong: "" },
            metric: { amount: 1.0, unitShort: "", unitLong: "" },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "1 1/2 cups Flour",
          originalName: "Flour",
          amount: 1.5,
          unit: "cups",
          meta: [],
          measures: {
            us: { amount: 1.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 354.882,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 8120,
          aisle: "Cereal",
          image: "rolled-oats.jpg",
          consistency: "solid",
          name: "oats",
          nameClean: "rolled oats",
          original: "1/2 cup Oats",
          originalName: "Oats",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: { amount: 0.5, unitShort: "cups", unitLong: "cups" },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/8 tsp Salt",
          originalName: "Salt",
          amount: 0.125,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
            metric: { amount: 0.125, unitShort: "tsps", unitLong: "teaspoons" },
          },
        },
        {
          id: 2050,
          aisle: "Baking",
          image: "vanilla-extract.jpg",
          consistency: "liquid",
          name: "vanilla",
          nameClean: "vanilla extract",
          original: "1 tsp Vanilla",
          originalName: "Vanilla",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
            metric: { amount: 1.0, unitShort: "tsp", unitLong: "teaspoon" },
          },
        },
      ],
      id: 646905,
      title: "Homemade Animal Crackers",
      readyInMinutes: 45,
      servings: 8,
      sourceUrl:
        "http://www.foodista.com/recipe/BPVBYNNB/homemade-animal-crackers",
      image: "https://spoonacular.com/recipeImages/646905-556x370.jpg",
      imageType: "jpg",
      summary:
        'Homemade Animal Crackers might be just the dessert you are searching for. This recipe makes 8 servings with <b>324 calories</b>, <b>4g of protein</b>, and <b>13g of fat</b> each. For <b>38 cents per serving</b>, this recipe <b>covers 7%</b> of your daily requirements of vitamins and minerals. 39 people were impressed by this recipe. Head to the store and pick up allspice, baking powder, butter, and a few other things to make it today. It is a good option if you\'re following a <b>vegetarian</b> diet. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 30%</b>. This score is rather bad. Try <a href="https://spoonacular.com/recipes/homemade-animal-crackers-205719">Homemade Animal Crackers</a>, <a href="https://spoonacular.com/recipes/animal-crackers-732741">Animal Crackers</a>, and <a href="https://spoonacular.com/recipes/animal-crackers-142292">Animal Crackers</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["side dish"],
      diets: ["lacto ovo vegetarian"],
      occasions: [],
      instructions:
        '<ol><li>Cream together the butter and brown sugar.</li><li>Add in the egg and vanilla and combine well.</li><li>Mix in the cinnamon, allspice, and salt.</li><li>Finally, add in the baking powder, oats, flour, and optional cocoa powder. Cocoa powder should be subbed for flour. Simply add the powder to your measuring cup and then fill the rest of the way up with flour.</li><li>Mix it up good and form into a ball. Store in the fridge for a minimum of one hour and up to overnight.</li><li>When ready, pull dough from fridge, grab off a hunk and roll it out to 1/4" thick.</li><li>Cut out crackers and place on a cookie sheet lined with parchment.</li><li>Bake for 5-7 minutes in an oven preheated to 350 degrees.</li></ol>',
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Cream together the butter and brown sugar.",
              ingredients: [
                {
                  id: 19334,
                  name: "brown sugar",
                  localizedName: "brown sugar",
                  image: "dark-brown-sugar.png",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1053,
                  name: "cream",
                  localizedName: "cream",
                  image: "fluid-cream.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Add in the egg and vanilla and combine well.",
              ingredients: [
                {
                  id: 1052050,
                  name: "vanilla",
                  localizedName: "vanilla",
                  image: "vanilla.jpg",
                },
                {
                  id: 1123,
                  name: "egg",
                  localizedName: "egg",
                  image: "egg.png",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Mix in the cinnamon, allspice, and salt.Finally, add in the baking powder, oats, flour, and optional cocoa powder. Cocoa powder should be subbed for flour. Simply add the powder to your measuring cup and then fill the rest of the way up with flour.",
              ingredients: [
                {
                  id: 18369,
                  name: "baking powder",
                  localizedName: "baking powder",
                  image: "white-powder.jpg",
                },
                {
                  id: 19165,
                  name: "cocoa powder",
                  localizedName: "cocoa powder",
                  image: "cocoa-powder.png",
                },
                {
                  id: 2001,
                  name: "allspice",
                  localizedName: "allspice",
                  image: "allspice-ground.jpg",
                },
                {
                  id: 2010,
                  name: "cinnamon",
                  localizedName: "cinnamon",
                  image: "cinnamon.jpg",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 8120,
                  name: "oats",
                  localizedName: "oats",
                  image: "rolled-oats.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404766,
                  name: "measuring cup",
                  localizedName: "measuring cup",
                  image: "measuring-cup.jpg",
                },
              ],
            },
            {
              number: 4,
              step: 'Mix it up good and form into a ball. Store in the fridge for a minimum of one hour and up to overnight.When ready, pull dough from fridge, grab off a hunk and roll it out to 1/4" thick.',
              ingredients: [
                {
                  id: 0,
                  name: "dough",
                  localizedName: "dough",
                  image: "pizza-dough",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [],
              length: { number: 60, unit: "minutes" },
            },
            {
              number: 5,
              step: "Cut out crackers and place on a cookie sheet lined with parchment.",
              ingredients: [
                {
                  id: 18621,
                  name: "crackers",
                  localizedName: "crackers",
                  image: "crackers.jpg",
                },
                {
                  id: 10118192,
                  name: "cookies",
                  localizedName: "cookies",
                  image: "shortbread-cookies.jpg",
                },
              ],
              equipment: [
                {
                  id: 404727,
                  name: "baking sheet",
                  localizedName: "baking sheet",
                  image: "baking-sheet.jpg",
                },
              ],
            },
            {
              number: 6,
              step: "Bake for 5-7 minutes in an oven preheated to 350 degrees.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: { number: 7, unit: "minutes" },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/homemade-animal-crackers-646905",
    },
    {
      vegetarian: true,
      vegan: true,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 0,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 17,
      spoonacularScore: 97.0,
      healthScore: 96.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 175.37,
      extendedIngredients: [
        {
          id: 9003,
          aisle: "Produce",
          image: "apple.jpg",
          consistency: "solid",
          name: "apples",
          nameClean: "apple",
          original: "apples",
          originalName: "apples",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 9042,
          aisle: "Produce",
          image: "blackberries.jpg",
          consistency: "solid",
          name: "blackberries",
          nameClean: "blackberries",
          original: "blackberries",
          originalName: "blackberries",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 10111251,
          aisle: "Produce",
          image: "romaine.jpg",
          consistency: "solid",
          name: "romaine lettuce",
          nameClean: "romaine",
          original: "Romaine lettuce",
          originalName: "Romaine lettuce",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 9316,
          aisle: "Produce",
          image: "strawberries.png",
          consistency: "solid",
          name: "strawberries",
          nameClean: "strawberries",
          original: "strawberries",
          originalName: "strawberries",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
        {
          id: 4135,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vinaigrette.jpg",
          consistency: "liquid",
          name: "vinaigrette",
          nameClean: "vinaigrette",
          original: "basalmic vinaigrette",
          originalName: "basalmic vinaigrette",
          amount: 1.0,
          unit: "serving",
          meta: [],
          measures: {
            us: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
            metric: { amount: 1.0, unitShort: "serving", unitLong: "serving" },
          },
        },
      ],
      id: 715540,
      title: "Summer Berry Salad",
      readyInMinutes: 45,
      servings: 1,
      sourceUrl: "http://www.pinkwhen.com/summer-berry-salad/",
      image: "https://spoonacular.com/recipeImages/715540-556x370.jpg",
      imageType: "jpg",
      summary:
        'Summer Berry Salad might be just the side dish you are searching for. Watching your figure? This caveman, gluten free, primal, and vegan recipe has <b>98 calories</b>, <b>2g of protein</b>, and <b>1g of fat</b> per serving. This recipe serves 1 and costs $1.75 per serving. 17 people have tried and liked this recipe. If you have apples, blackberries, romaine lettuce, and a few other ingredients on hand, you can make it. It can be enjoyed any time, but it is especially good for <b>The Fourth Of July</b>. From preparation to the plate, this recipe takes approximately <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 98%</b>. This score is outstanding. Try <a href="https://spoonacular.com/recipes/berry-summer-salad-50848">Berry Summer Salad</a>, <a href="https://spoonacular.com/recipes/summer-berry-salad-485592">Summer Berry Salad</a>, and <a href="https://spoonacular.com/recipes/chicken-berry-summer-salad-769303">Chicken & Berry Summer Salad</a> for similar recipes.',
      cuisines: [],
      dishTypes: ["salad"],
      diets: [
        "gluten free",
        "dairy free",
        "paleolithic",
        "lacto ovo vegetarian",
        "primal",
        "vegan",
      ],
      occasions: ["4th of july", "summer"],
      instructions:
        "Cut up a Granny Smith green apple, strawberries, and add blackberriesMix in with Romaine lettuceToss in some basalmic vinaigrette",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Cut up a Granny Smith green apple, strawberries, and add blackberries",
              ingredients: [
                {
                  id: 9042,
                  name: "blackberries",
                  localizedName: "blackberries",
                  image: "blackberries.jpg",
                },
                {
                  id: 9316,
                  name: "strawberries",
                  localizedName: "strawberries",
                  image: "strawberries.png",
                },
                {
                  id: 1069003,
                  name: "green apple",
                  localizedName: "green apple",
                  image: "grannysmith-apple.png",
                },
              ],
              equipment: [],
            },
            {
              number: 2,
              step: "Mix in with Romaine lettuce",
              ingredients: [
                {
                  id: 10111251,
                  name: "romaine",
                  localizedName: "romaine",
                  image: "romaine",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Toss in some basalmic vinaigrette",
              ingredients: [
                {
                  id: 4135,
                  name: "vinaigrette",
                  localizedName: "vinaigrette",
                  image: "vinaigrette.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/summer-berry-salad-715540",
    },
  ],
};
